export default class ContactUsConfig {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.commentConfig1 = rawData.commentConfig1
      this.commentConfig2 = rawData.commentConfig2
      this.commentConfig3 = rawData.commentConfig3
      this.commentConfig4 = rawData.commentConfig4
    }
  }